var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1405_8339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2584 5.43568C14.9332 5.11068 14.4079 5.11068 14.0827 5.43568L10.0055 9.50234L5.92831 5.42734C5.60313 5.10234 5.07785 5.10234 4.75267 5.42734C4.42749 5.75234 4.42749 6.27734 4.75267 6.60234L8.82989 10.6773L4.75267 14.7523C4.42749 15.0773 4.42749 15.6023 4.75267 15.9273C5.07785 16.2523 5.60313 16.2523 5.92831 15.9273L10.0055 11.8523L14.0827 15.9273C14.4079 16.2523 14.9332 16.2523 15.2584 15.9273C15.5836 15.6023 15.5836 15.0773 15.2584 14.7523L11.1812 10.6773L15.2584 6.60234C15.5752 6.28568 15.5752 5.75234 15.2584 5.43568V5.43568Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1405_8339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0109,
    height: 20,
    fill: "white",
    transform: "translate(0 0.675781)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.757883b38b9d6fbf229fd7316e38326d.svg";
export { ForwardRef as ReactComponent };